module.exports = __webpack_public_path__ + "static/media/NunitoSans-Italic.451d4026.ttf";